import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

// 공용코드 맵
const allCommonCodeMap =()=>{
    return customAxios.post(myIpAddress+'/commonCode/allCommonCodeMap',);
}
export default allCommonCodeMap;